module.exports = __webpack_public_path__ + "static/media/jdrManoir_03_full.469efb9f.png";